module.exports = __webpack_public_path__ + "static/media/digital-marketing.113efe69.jpg";